// extracted by mini-css-extract-plugin
module.exports = {"circleIcon":"circleCheckbox_circleIcon__XwHRe","selected":"circleCheckbox_selected__1lH3z"};